module.exports = __webpack_public_path__ + "img/亮2.271f4274.png";